import { React, useState, useEffect, useRef } from "react";
import MiscUploadPDFView from "../misc_components/MiscUploadPDFView";
import Footer from "../Footer";
import NavBar from "../NavBar";
import MiscPageTitle from "../misc_components/MiscPageTitle";
import MiscPageMidSection from "../misc_components/MiscPageMidSection";
import HomeScreenHowToUse from "../home_screen/HomeScreenHowToUse";
import MiscWhyUse from "../misc_components/MiscWhyUse";
import MiscPageLookingFor from "../misc_components/MiscPageLookingFor";
import LoadingBar from "react-top-loading-bar";
import { useLocation, ScrollRestoration } from "react-router-dom";
import { PageContext } from "../../App";
import { BASE_URL } from "../Config";
import RepairPDFImageListScreen from "./RepairPDFImageListScreen";
import MiscFAQ from "../misc_components/MiscFAQ";
import MiscRecommendedPages from "../misc_components/MiscRecommendedPages";

function RepairPDFMain() {
  //location
  const location = useLocation();
  // Use optional chaining or a guard in case state is undefined
  const { title } = location.state || { title: "Repair PDF files" };

  //selected files
  const [selectedFiles, setSelectedFiles] = useState([]);
  //show edit screen
  const [showEditFileScreen, setShowEditFileScreen] = useState(false);
  //start processing
  const [startProcessingFiles, setStartProcessingFiles] = useState(false);

  //reference loading bar
  const loadingBarRef = useRef(null);

  //looking for object
  //requires 3 data objects
  //to show keywarded navigation
  const lookingForObject = {
    data1: { link: "/repair_pdf", title: "Fix Corrupted PDF Files" },
    data2: { link: "/repair_pdf", title: "PDF Repair Tool" },
    data3: { link: "/repair_pdf", title: "Retrieve Corrupted PDF Pages" },
  };

  //use effect to handle the submit button click
  useEffect(() => {
    //check
    if (startProcessingFiles === true) {
      //show file edit screen
      setShowEditFileScreen(true);

      console.log(
        "Start file processing. Number of files: ",
        selectedFiles.length,
      );
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [startProcessingFiles]);

  return (
    <PageContext.Provider
      value={{
        selectedFiles,
        setSelectedFiles,
        startProcessingFiles,
        setStartProcessingFiles,
        setShowEditFileScreen,
      }}
    >
      {/* Scroll to top */}
      <ScrollRestoration />
      {/* Loading Bar */}
      <LoadingBar ref={loadingBarRef} />

      {/*Add title and metadata */}
      <title>{title + " Offline"}</title>
      <meta name="robots" content="index, follow"></meta>
      <link
        rel="canonical"
        href={`${BASE_URL}${lookingForObject.data1.link}`}
      />
      <meta
        name="description"
        content="Repair PDF files online easily. Fix corrupted or damaged PDFs and restore documents quickly with our fast and secure PDF repair tool."
      ></meta>
      <meta
        name="keywords"
        content="repair pdf, pdf repair tool, fix pdf, repair pdf online, corrupted pdf repair, damaged pdf fix, pdf file repair, recover pdf files, pdf fixer, online pdf repair, restore pdf document, pdf error fix, fix broken pdf, pdf recovery tool, secure pdf repair"
      ></meta>

      {/* page content */}
      {showEditFileScreen ? (
        <RepairPDFImageListScreen title={title}></RepairPDFImageListScreen>
      ) : (
        <div>
          {/* Nav Bar */}
          <NavBar />
          {/* Title */}
          <MiscPageTitle title={title} online={false} />
          {/* Upload PDF View */}
          <MiscUploadPDFView
            selectMultiple={true}
            filetype={{ "application/pdf": [".pdf"] }}
          />
          {/* Mid Section */}
          <MiscPageMidSection description="This repair PDF website that works offline is a reliable solution for fixing damaged, corrupted, or unreadable PDF files without depending on an internet connection. Our offline PDF repair tool helps recover broken PDFs caused by incomplete downloads, system crashes, file transfer errors, or software issues. By processing files locally, a repair PDF tool ensures maximum privacy and security, making it ideal for sensitive documents used by businesses, professionals, and institutions. Users can quickly repair PDF files offline, restore document structure, fix missing pages, and recover readable text while preserving original formatting. This offline PDF repair solution is fast, stable, and works even in restricted or low-connectivity environments. It supports a wide range of PDF versions and file sizes, making it suitable for everyday document recovery needs. Whether you need to fix a corrupted invoice, report, form, or scanned document, a repair PDF website offers an efficient and secure way to restore files and continue working without data loss." />
          {/* How to use */}
          <HomeScreenHowToUse
            steps={{
              step1: "Select",
              step2: "Offline",
              step3: "Repair",
              step4: "Download",
            }}
          />
          {/* Why use section */}
          <MiscWhyUse
            title="PDF Repair Tool"
            why_use={[
              {
                title: "Fix Corrupted and Damaged PDF Files",
                description:
                  "Our repair PDF website helps fix corrupted, damaged, or unreadable documents caused by download errors or system crashes. Using a PDF repair tool makes it easy to repair PDF files quickly.",
              },
              {
                title: "Work Offline for Maximum Privacy",
                description:
                  "This offline repair PDF tool processes files locally, ensuring data security and privacy. Repair PDF offline is ideal for confidential and sensitive documents.",
              },
              {
                title: "Recover Important Data and Content",
                description:
                  "PDF repair tools help recover text, images, and document structure from broken files, preventing data loss and saving time.",
              },
              {
                title: "Restore PDFs Without Recreating Files",
                description:
                  "Using a repair PDF website eliminates the need to recreate documents from scratch by fixing existing PDF files efficiently.",
              },
              {
                title: "Fast and Reliable Document Recovery",
                description:
                  "Offline PDF repair tools provide fast and stable performance without relying on internet connectivity.",
              },
              {
                title: "Support for Multiple PDF Versions",
                description:
                  "Our PDF repair tool supports different PDF versions and file sizes, making it suitable for repairing a wide range of documents.",
              },
              {
                title: "Useful for Business and Professional Use",
                description:
                  "Professionals and businesses rely on repair PDF tools to fix invoices, reports, contracts, and official documents.",
              },
              {
                title: "Easy to Use and Beginner-Friendly",
                description:
                  "Our repair PDF website offers a simple interface that allows users to repair PDF files without technical knowledge.",
              },
              {
                title: "Save Time and Reduce Downtime",
                description:
                  "Repairing PDF files quickly helps avoid delays and interruptions in work caused by corrupted documents.",
              },
            ]}
          />
          {/* FAQ */}
          <MiscFAQ
            faq_list={[
              {
                title: "What is a PDF repair tool?",
                description:
                  "A PDF repair tool helps fix problems that prevent a PDF file from opening, displaying correctly, or being processed. Depending on the type of damage, it may help recover readable content or rebuild parts of the document structure.",
              },
              {
                title: "How can I repair a corrupted PDF for free?",
                description:
                  "Open the PDF repair tool on ShivaPDF.com and select the damaged PDF file. Start the repair process and download the repaired document if recovery is successful and the tool provides an output file.",
              },
              {
                title: "Can I repair a PDF offline?",
                description:
                  "Yes, if the PDF repair tool supports local processing, you may be able to repair files without an internet connection after the tool has loaded. Offline availability depends on the implementation and whether all required resources are available locally.",
              },
              {
                title: "Does ShivaPDF upload my PDF during repair?",
                description:
                  "A locally processed PDF repair tool can analyze and repair files directly in your browser without sending them to a server. Check ShivaPDF's implementation and privacy policy to verify how your documents are handled.",
              },
              {
                title: "Why is my PDF file corrupted?",
                description:
                  "PDF corruption can happen because of an interrupted download, an incomplete file transfer, storage errors, software crashes, or problems while creating or saving the document. Sometimes the file is incomplete rather than genuinely corrupted.",
              },
              {
                title: "Why can't I open my PDF file?",
                description:
                  "A PDF may fail to open because it is damaged, incomplete, password-protected, or incompatible with the viewer. Try downloading the file again, opening it with another PDF reader, or using a repair tool if the file appears corrupted.",
              },
              {
                title: "Can a PDF repair tool fix a damaged PDF?",
                description:
                  "A PDF repair tool may fix certain structural problems and recover readable content. Success depends on the extent of the damage, the PDF structure, and whether essential document data is still available.",
              },
              {
                title: "Can I recover data from a corrupted PDF?",
                description:
                  "Some corrupted PDFs still contain recoverable text, images, or page information. A repair tool may restore access to some of that content, but severely damaged or incomplete files may not be fully recoverable.",
              },
              {
                title: "Can I repair a PDF that shows a blank page?",
                description:
                  "A blank page may result from damaged content, a rendering problem, or an issue with the original document. Try another PDF viewer first; if the file itself is damaged, a repair tool may help depending on the cause.",
              },
              {
                title: "Can I repair a PDF that displays an error message?",
                description:
                  "Yes, a repair tool may help if the error is caused by a damaged PDF structure. If the problem is caused by an incorrect password, unsupported encryption, or a missing file, repairing the PDF may not resolve it.",
              },
              {
                title: "Can I repair a partially downloaded PDF?",
                description:
                  "A partially downloaded PDF may be missing important data that a repair tool cannot reconstruct. Download the original file again if possible, then try repairing it if the complete download still fails to open.",
              },
              {
                title: "Can I repair a password-protected PDF?",
                description:
                  "Repairing an encrypted or password-protected PDF depends on the encryption method and the tool's capabilities. You may need the correct password before the document can be opened or processed.",
              },
              {
                title: "Can I repair a scanned PDF?",
                description:
                  "A scanned PDF may be repairable if its document structure is damaged but its embedded page images remain intact. If the scanned images themselves are missing or corrupted, the original scans may be needed.",
              },
              {
                title: "Can I repair a PDF without losing its content?",
                description:
                  "A repair attempt may preserve most readable content, but no repair method can guarantee complete recovery. Keep a backup of the original PDF and carefully check the repaired document before relying on it.",
              },
              {
                title: "Will repairing a PDF change its formatting?",
                description:
                  "Some repair operations can affect page rendering, fonts, images, links, or other document elements, depending on the damage and recovery method. Review the repaired file to make sure its pages display correctly.",
              },
              {
                title: "Can I repair a PDF on my phone?",
                description:
                  "You can use a compatible browser-based PDF repair tool on an iPhone or Android device if the tool supports mobile browsers. Select the damaged file, run the repair process, and save the result if recovery succeeds.",
              },
              {
                title: "Can I repair a PDF on Windows or Mac?",
                description:
                  "A browser-based PDF repair tool can work on compatible Windows and Mac computers. Open ShivaPDF.com in a supported browser and select the damaged PDF if the tool is available for your device.",
              },
              {
                title: "Can I repair a PDF without installing software?",
                description:
                  "A web-based PDF repair tool can let you attempt repairs through a browser without installing a separate desktop application. The available repair options depend on the tool's supported features.",
              },
              {
                title: "Is ShivaPDF's PDF repair tool free?",
                description:
                  "ShivaPDF provides PDF tools for common document tasks. Check the PDF repair page for current availability, file-size limits, and any usage restrictions before processing your document.",
              },
              {
                title: "Can I repair a PDF without creating an account?",
                description:
                  "You may be able to use the PDF repair tool without registering if account creation is not required. Check the current ShivaPDF page for any access or usage requirements.",
              },
              {
                title: "What should I do if PDF repair fails?",
                description:
                  "Try downloading the original file again, opening it in another PDF reader, or using a backup copy. If the file remains damaged, the document creator may need to provide a new copy because severely corrupted data may be unrecoverable.",
              },
              {
                title: "Can I repair a large PDF file?",
                description:
                  "Repairing a large PDF depends on the tool's file-size limits, available device memory, and the extent of the damage. If processing fails, try a smaller file or work from a device with more available memory.",
              },
              {
                title: "Is it safe to repair confidential PDF files online?",
                description:
                  "For confidential documents, use a tool with a clear privacy policy and verified local processing if you want files to remain on your device. Avoid sending sensitive documents to online services unless you understand how they process and store files.",
              },
              {
                title: "Can every corrupted PDF be repaired?",
                description:
                  "No. A repair tool cannot guarantee recovery of every corrupted PDF. If essential data is missing, overwritten, or severely damaged, the best option may be to recover a backup or obtain the original document again.",
              },
            ]} />
          {/* Looking for section */}
          <MiscPageLookingFor data={lookingForObject} />
          {/* Recommended Tools */}
          <MiscRecommendedPages />
          {/* Footer */}
          <Footer />
        </div>
      )}
    </PageContext.Provider>
  );
}

export default RepairPDFMain;
